import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const drawerPaper =
  (isMobile: boolean): SxProps<Theme> =>
  (theme) => ({
    width: isMobile ? "100%" : 460,
    maxWidth: "100%",
    maxHeight: isMobile ? "86vh" : "86vh",
    borderRadius: isMobile ? `${theme.spacing(2.75)} ${theme.spacing(2.75)} 0 0` : theme.spacing(2.75),
    p: theme.spacing(isMobile ? 2.5 : 3.25),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.25),
    mx: isMobile ? 0 : "auto",
  });

export const header: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 1.5,
};

export const profileRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
};

export const avatar: SxProps<Theme> = (theme) => ({
  width: 46,
  height: 46,
  borderRadius: "50%",
  bgcolor: alpha(theme.palette.primary.main, 0.12),
  color: "primary.main",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: "1.0625rem",
  flexShrink: 0,
});

export const phone: SxProps<Theme> = {
  direction: "ltr",
  textAlign: "start",
  color: "text.secondary",
};

export const infoGrid: SxProps<Theme> = (theme) => ({
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  gap: theme.spacing(1.25),
});

export const infoCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.default",
  borderRadius: 1.75,
  p: theme.spacing(1.5, 1.75),
  display: "flex",
  flexDirection: "column",
  gap: 0.375,
});

export const infoLabel: SxProps<Theme> = {
  fontSize: "0.6875rem",
  color: "text.secondary",
  fontWeight: 600,
};

export const infoValue: SxProps<Theme> = {
  fontSize: "0.9375rem",
  fontWeight: 700,
};

export const statsRow: SxProps<Theme> = (theme) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(1.25),
});

export const sectionTitle: SxProps<Theme> = {
  fontSize: "0.9375rem",
  fontWeight: 700,
};

export const orderList: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
});

export const orderItem: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(1.5),
  p: theme.spacing(1.5, 1.75),
  borderRadius: 1.75,
  border: `1px solid ${theme.palette.divider}`,
  cursor: "pointer",
  transition: "background 0.15s ease",
  "&:hover": {
    bgcolor: "action.hover",
  },
});

export const loadingWrap: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  py: 4,
};

export const emptyOrders: SxProps<Theme> = {
  py: 2,
  textAlign: "center",
  color: "text.secondary",
  fontSize: "0.84375rem",
};
